import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TextField, SelectField } from 'packages/shared/core';
import Close from '@mui/icons-material/Close';

const useStyles = makeStyles((theme) => ({
    title: {
        marginBottom: '20px'
    },
    titleWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    closeBg: {
        width: '40px',
        height: '40px',
        background: theme.mind.secondaryBackgroundColor[500]
    },
    button: {
        marginLeft: 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        marginTop: '15px',

        '&:hover': {
            background: theme.palette.primary[900]
        }
    }
}));

//queries
const AddUser = (props) => {
    const { handleClose, form, onSubmit } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <div className={classes.titleWrapper}>
                <Typography className={classes.title} variant="h1" component="h2">
                    {t('GENERAL.ADDCOACH')}
                </Typography>
                <IconButton className={classes.closeBg} aria-label="delete" onClick={handleClose}>
                    <Close />
                </IconButton>
            </div>
            <TextField
                multiline
                fullWidth
                label={t('GENERAL.FIRSTNAME')}
                name="firstName"
                form={form}
                type="firstName"
                value={form.fields.firstName || ''}
            />
            <TextField
                multiline
                fullWidth
                label={t('GENERAL.LASTNAME')}
                name="lastName"
                form={form}
                type="lastName"
                value={form.fields.lastName || ''}
            />
            <TextField
                multiline
                fullWidth
                label={t('GENERAL.MAIL')}
                name="email"
                form={form}
                type="email"
                value={form.fields.email || ''}
            />
            <SelectField
                label={t('GENERAL.ROLE')}
                options={[
                    { label: 'Admin', value: 'admin' },
                    { label: 'Coach', value: 'coach' }
                ]}
                name="role"
                form={form}
                type="role"
                value={form.fields.role || ''}
            />

            <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={onSubmit}
            >
                {t('GENERAL.ADDCOACH')}
            </Button>
        </div>
    );
};

export default AddUser;
